import {useSearchParams} from "react-router";
import {Template} from "../../../components/template/template.jsx";
import Content from "./components/content.jsx";
import {Card} from "../../../components/card/card.jsx";
import {useRef, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import OccurrenceHistoryService from "../../../services/reports/occurrence-history-service.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";

export default function OccurrenceHistory() {
    const [searchParams] = useSearchParams();
    const [isPrinting, setIsPrinting] = useState(false);
    const [headerSelected, setHeaderSelected] = useState(-1);
    const printComponentRef = useRef(null);
    const occurrenceId = searchParams.get("occurrenceid");
    const title = "Histórico da ocorrência";

    const { data: reportOccurrence, isLoading } = useQuery({
        queryKey: ['occurrence-history', occurrenceId],
        queryFn: () => OccurrenceHistoryService.getOccurrenceHistory(occurrenceId),
        enabled: !!occurrenceId,
    });

    const hasData = Array.isArray(reportOccurrence?.occ) && reportOccurrence.occ.length > 0;

    return (
        <Template isLoading={isLoading || isPrinting}>
            <Template.Header>
                <Template.Title>{title}</Template.Title>
                <HeaderButtons
                    printable={true}
                    headerChange={true}
                    printComponentRef={printComponentRef}
                    reportData={reportOccurrence}
                    data={hasData}
                    headerSelected={headerSelected}
                    setHeaderSelected={setHeaderSelected}
                />
            </Template.Header>
            <Template.Body>
                <Card>
                    <Card.Body>
                        <Content
                            reportData={reportOccurrence}
                            data={hasData}
                            entity={headerSelected}
                            title={title}
                            printComponentRef={printComponentRef}
                            setIsPrinting={setIsPrinting}
                        />
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}